type KeyboardListener = (e: KeyboardEvent) => void;

const onDownListeners: KeyboardListener[] = [];
const onUpListeners: KeyboardListener[] = [];

document.addEventListener(
    'keydown',
    (e) => {
        onDownListeners.forEach((listener) => listener(e));
    },
    true,
);

document.addEventListener('keyup', (e) => {
    onUpListeners.forEach((listener) => listener(e));
});

export function addOnDownListener(listener: KeyboardListener) {
    onDownListeners.push(listener);
}

export function addOnUpListener(listener: KeyboardListener) {
    onUpListeners.push(listener);
}

export function removeOnDownListener(listener: KeyboardListener) {
    const index = onDownListeners.indexOf(listener);
    onDownListeners.splice(index, 1);
}

export function removeOnUpListener(listener: KeyboardListener) {
    const index = onUpListeners.indexOf(listener);
    onUpListeners.splice(index, 1);
}
